<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="container-fluid padding-bottom-small bottom-padding">
    <div class="col-sm-11 center-block">

        <div *ngIf="orderRevisionId; else elseTitleBlock"><h1 tabindex="0" aria-label="Edit Order">Edit Order</h1></div>
        <ng-template #elseTitleBlock><h1 tabindex="0" aria-label="Add Order">Add Order</h1></ng-template>

        <form [formGroup]="orderStep1Form"
              novalidate>
            <div class="row">
                <!--------------------------------
                LEFT PANEL
                --------------------------------->
                <div class="col-sm-9">
                    <!--------------------------------
                    HEADER BUTTONS
                    --------------------------------->
                    <div class="row">

                      <div class="col-sm-4">
                          <div class="card mb-5" tabindex="0" aria-label="Order Type">
                              <div class="card-header bg-primary text-white">
                                  <span class="badge bg-white text-primary">1</span>&nbsp;<b>ORDER TYPE</b>
                              </div>
                          </div>
                      </div>

                      <ng-container *ngIf="orderRevisionId; else elseBlock">

                        <div class="col-sm-4">
                          <a [routerLink]="['/order-step-2/', orderRevisionId]" class="text-decoration-none">
                            <div class="card mb-5" role="button" tabindex="0" aria-label="Additional Options">
                              <div class="card-header">
                                <span class="badge bg-dark text-white">2</span>&nbsp;<b class="text-dark">ADDITIONAL OPTIONS</b>
                              </div>
                            </div>
                          </a>
                        </div>

                        <div class="col-sm-4">
                          <a [routerLink]="['/order-step-3/', orderRevisionId]" class="text-decoration-none">
                            <div class="card mb-5" role="button" tabindex="0" aria-label="Place Order">
                              <div class="card-header">
                                <span class="badge bg-dark text-white">3</span>&nbsp;<b class="text-dark">PLACE ORDER</b>
                              </div>
                            </div>
                          </a>
                        </div>

                      </ng-container>

                        <ng-template #elseBlock>
                            <div class="col-sm-4">
                                <div class="card mb-5" tabindex="0" aria-label="Additional Options">
                                    <div class="card-header">
                                        <span class="badge bg-dark text-white">2</span>&nbsp;ADDITIONAL OPTIONS
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="card mb-5" tabindex="0"  aria-label="Place Order"   >
                                    <div class="card-header">
                                        <span class="badge bg-dark text-white">3</span>&nbsp;PLACE ORDER
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>


                    <!--------------------------------
                    SERVICE GROUP
                    --------------------------------->
                    <div class="row">
                        <div class="col-sm-12">
                            <label class="form-label-control" tabindex="0" aria-label="What type of order would you like to place?">What type of order would you like to place?</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <ejs-dropdownlist #serviceGroup
                                              [dataSource]='serviceGroupsLOV'
                                              aria-label="service group dropdown"
                                              aria-required="required"
                                              role="list"
                                              [fields]='ddwFields'
                                              [placeholder]='servGroupWaterMark'
                                              [popupHeight]='ddwHeight'
                                              formControlName="serviceGroup"
                                              (change)="serviceGroupChanged($event)"
                                              class="required">
                            </ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            &nbsp;
                        </div>
                    </div>

                    <!--------------------------------
                    ORDER TYPE
                    --------------------------------->
                    <div class="row" *ngIf="showOrderType">
                        <div class="col-sm-12">
                            <label class="form-label-control" tabindex="0" aria-label="Are you requesting an initial registration or updating an existing registration?">Are you requesting an initial registration or updating an existing registration?</label>
                        </div>
                    </div>

                    <div class="row" *ngIf="showOrderType">
                        <div class="col-sm-4">
                            <div class="card mb-5 radio-container" [ngClass]="{'red-border': !isOrderTypeSelected()}">
                                    <ejs-radiobutton label='<b>Initial</b>'
                                                     aria-label="Full Conversion"
                                                     role="radio"
                                                     [value]="orderService.SERVICE_CATEGORY_FULL_CONVERSION"
                                                     name="serviceCategory"
                                                     formControlName="serviceCategory"
                                                     labelPosition="After"
                                                     (change)="serviceCategoryChanged($event)"
                                                     [disabled]="!canEdit">
                                    </ejs-radiobutton>
                              </div>
                          </div>

                        <div class="col-sm-4">
                                <div class="card-header" tabindex="0">
                                  <div class="card mb-5 radio-container" [ngClass]="{'red-border': !isOrderTypeSelected()}">
                                    <ejs-radiobutton label='<b>Update</b>' [value]="orderService.SERVICE_CATEGORY_PARTIAL_CONVERSION"
                                                     role="radio"
                                                     aria-label="Partial Conversion"
                                                     name="serviceCategory"
                                                     formControlName="serviceCategory"
                                                     labelPosition="After"
                                                     (change)="serviceCategoryChanged($event)"
                                                     [disabled]="!canEdit">
                                    </ejs-radiobutton>
                                </div>
                            </div>
                        </div>
                    </div>

                     <!--------------------------------
                    SERVICE TYPE
                    --------------------------------->
                    <div class="row">
                        <div class="col-sm-12">
                            <label class="form-label-control" tabindex="0" aria-label="Service type Label">Service Type</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <ejs-dropdownlist #serviceTypeId
                                              [dataSource]='serviceTypesLOV'
                                              aria-label="service type dropdown"
                                              aria-required="required"
                                              role="list"
                                              [fields]='ddwFields'
                                              [placeholder]='servTypesWaterMark'
                                              [popupHeight]='ddwHeight'
                                              formControlName="serviceTypeId"
                                              [enabled]="isServiceTypeEnabled"
                                              (change)='serviceTypeChanged($event)'
                                              class="required">
                            </ejs-dropdownlist>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            &nbsp;
                        </div>
                    </div>

                    <!--------------------------------
                    DELIVERY PRIORITY
                    --------------------------------->
                    <div class="row">
                        <div class="col-sm-12">
                            <label class="form-label-control" tabindex="0" aria-label="Delivery Priority">Delivery Priority (select one)</label>
                        </div>
                    </div>

                    <div class="row">
                      <div [style.display]="hasRegularPriority ? 'block' : 'none'" class="col-sm-4">
                          <div class="card mb-5 radio-container" [ngClass]="{'red-border': !isDeliveryPrioritySelected()}">
                                  <ejs-radiobutton label='<b>Regular</b>'
                                                   value="{{orderService.DELIVERY_PRIORITY_REGULAR}}"
                                                   aria-label="Regular"
                                                   tabindex="0"
                                                   role="radiogroup"
                                                   name="deliveryPriority"
                                                   formControlName="deliveryPriority"
                                                   [disabled]="!isDeliveryPriorityEnabled"
                                                   labelPosition="After">
                                  </ejs-radiobutton>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div [style.display]="hasExpeditedPriority ? 'block' : 'none'" class="card mb-5 radio-container" [ngClass]="{'red-border': !isDeliveryPrioritySelected()}">
                                  <ejs-radiobutton label='<b>Expedited</b> <i>(fees apply)</i>'
                                                   value="{{orderService.DELIVERY_PRIORITY_EXPEDITED}}"
                                                   aria-label="Expedited"
                                                   tabindex="0"
                                                   role="radiogroup"
                                                   name="deliveryPriority"
                                                   formControlName="deliveryPriority"
                                                   [disabled]="!isDeliveryPriorityEnabled"
                                                   labelPosition="After">
                                  </ejs-radiobutton>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div [style.display]="hasEmergencyPriority ? 'block' : 'none'" class="card mb-5 radio-container" [ngClass]="{'red-border': !isDeliveryPrioritySelected()}">
                                  <ejs-radiobutton label='<b>Emergency</b> <i>(fees apply)</i>'
                                                   value="{{orderService.DELIVERY_PRIORITY_EMERGENCY}}"
                                                   aria-label="Emergency"
                                                   tabindex="0"
                                                   role="radiogroup"
                                                   name="deliveryPriority"
                                                   formControlName="deliveryPriority"
                                                   [disabled]="!isDeliveryPriorityEnabled"
                                                   labelPosition="After">
                                  </ejs-radiobutton>
                          </div>
                      </div>
                  </div>

                    <div class="row">
                        <!--------------------------------
                        ORDER NAME
                        --------------------------------->
                        <div class="col-sm-4">
                            <div>
                                <label for="orderName" id="orderName-label">Order name</label><br />
                                <input type="text"
                                       formControlName="orderName"
                                       aria-label="Enter order name"
                                       aria-labelledby="orderName-label"
                                       tabindex="0"
                                       name="orderName"
                                       class="form-control required"
                                       maxlength="255"
                                       [ngClass]="{'is-invalid': orderStep1Form.controls.orderName.errors }"
                                       [readonly]="!canEdit" />
                            </div>
                        </div>

                        <!--------------------------------
                        ORDER OWNERS
                        --------------------------------->
                        <div class="col-sm-4">
                            <div>
                                <label for="orderOwners" id="orderOwners-label">Order owner(s)</label><br />
                                <ejs-multiselect #drpOrderOwners
                                                 id="drpOrderOwners"
                                                 formControlName='drpOrderOwners'
                                                 [dataSource]='orderOwnersLOV'
                                                 aria-label="Enter order owners"
                                                 aria-labelledby="orderOwners-label"
                                                 tabindex="0"
                                                 mode='box'
                                                 [fields]='orderOwnersFields'
                                                 [placeholder]='orderOwnersWaterMark'
                                                 [popupHeight]='ddwHeight'
                                                 [ngClass]="{ 'is-invalid': false }"
                                                 (change)='ddwChanged($event)'
                                                 [readonly]="!canEdit">
                                </ejs-multiselect>
                            </div>
                            <div *ngFor="let inactiveOrderOwner of inactiveOrderOwnersList;" class="row">
                                <div class="row top-space">
                                    <app-warning-icon #warningContact [name]="inactiveOrderOwner.name" [bIsOrder]="bIsOrder"></app-warning-icon>
                                </div>
                            </div>
                        </div>

                        <!--------------------------------
                        EMAIL RECIPIENTS
                        --------------------------------->
                        <div class="col-sm-4">
                            <div>
                                <label for="drpOrderRecipients" id="drpOrderRecipients-label">Email recipient(s)</label><br />
                                <ejs-multiselect #drpOrderRecipients
                                                 id="drpOrderRecipients"
                                                 formControlName='drpOrderRecipients'
                                                 [dataSource]='orderRecipientsLOV'
                                                 mode='box'
                                                 aria-label="Select recipients"
                                                 aria-labelledby="drpOrderRecipients-label"
                                                 tabindex="0"
                                                 [fields]='orderRecipientsFields'
                                                 [placeholder]='orderRecipientsWaterMark'
                                                 [popupHeight]='ddwHeight'
                                                 [ngClass]="{ 'is-invalid': false }"
                                                 [readonly]="!canEdit">
                                </ejs-multiselect>
                            </div>
                            <div *ngFor="let inactiveOrder of inactiveOrderEmailRecipientList;" class="row">
                                <div class="row top-space">
                                    <app-warning-icon #warningContact [name]="inactiveOrder.name" [bIsOrder]="bIsOrder"></app-warning-icon>
                                 </div>
                            </div>
                        </div>
                    </div>

                    <!--------------------------------
                    BUTTONS
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <a class="btn btn-default" routerLink="/order-tracker" aria-label="Back to list">
                                <i class="fas fa-angle-left" aria-hidden="true"></i>
                                Back to list
                            </a>

                            <button class="btn btn-primary float-end mx-1" role="button" aria-label="Next Step"
                                    (click)="saveData('STEP2')" (keydown.enter)="saveData('STEP2')"
                                    id="btnNext"
                                    [disabled]="!orderStep1Form.valid || (pageState !== orderService.PAGE_STATE_READY)">
                                Next Step
                                <i class="fas fa-angle-double-right" aria-hidden="true"></i>
                            </button>
                            <button class="btn btn-info float-end mx-2" role="button" aria-label="Save button"
                                    (click)="saveData('STEP1');" (keydown.enter)="saveData('STEP1');"
                                    [disabled]="!orderStep1Form.valid || (pageState !== orderService.PAGE_STATE_READY) || !(canEdit || orderAdmin)">
                                {{saveButtonCaption}}
                            </button>
                            <button class="btn btn-info float-end" role="button" aria-label="Request Order Cancellation"
                                    (click)="saveData('CANCEL');" (keydown.enter)="saveData('CANCEL');"
                                    *ngIf="canRequestCancellation">
                                Request Order Cancellation
                            </button>
                        </div>
                    </div>

                    <!--------------------------------
                    ERROR MESSAGE
                    --------------------------------->
                    <div class="row">
                        <div class="col-md-12 top-space">
                            <div *ngIf="errorMessage!=null && errorMessage!=''" class="alert-text left-padding alert">{{errorMessage}}</div>
                        </div>
                    </div>

                </div>

                <!--------------------------------
                RIGHT PANEL
                --------------------------------->
                <div *ngIf="orderRevisionId" class="col-sm-3">
                    <!--------------------------------
                    ORDER SUMMARY
                    --------------------------------->
                    <order-summary #orderSummaryComponent
                                   whichStep="STEP1"
                                   [order]="order"
                                   [allEmployeesInCompany]="allEmployeesInCompany"
                                   [serviceCategories]="serviceCategories">
                    </order-summary>

                    <p>&nbsp;</p>

                    <!--------------------------------
                    ORDER ADMIN
                    --------------------------------->
                    <order-admin #orderAdminComponent
                                 *ngIf="canOrderAdmin"
                                 [orderStatuses]="orderStatuses"
                                 [order]="order"
                                 [canEdit]="canEdit"
                                 [postSaveDataNewOrderRevisionId]="postSaveDataNewOrderRevisionId"
                                 [deliveryDoc]="deliveryDoc"
                                 (onOrderAdminFileUpload)="onOrderAdminFileUpload($event)"
                                 (onIngestFilechanged)="onIngestFilechanged($event)">

                    </order-admin>
                </div>
            </div>
        </form>

        <!--------------------------------
        PROGRESS SPINNER
        --------------------------------->
        <div *ngIf="pageState !== this.orderService.PAGE_STATE_READY">
            <div id="loading"></div>
        </div>
    </div>
  </div>
</main>


